import type { FireflyRuntime } from "@squide/firefly";
import { registerLazyI18nextInstance } from "@packages/core-client/i18n/registerLazyI18nextInstance.ts";

export const routinesI18NextInstanceKey = "routines-domain";

export function initRoutinesI18next(runtime: FireflyRuntime) {
    registerLazyI18nextInstance(runtime, routinesI18NextInstanceKey, {
        "en-US": async () => (await import("./en.ts")).en,
        "fr-CA": async () => (await import("./fr.ts")).fr
    });
}
